import {Checkbox} from '@mui/material';
import React, {useState} from 'react';
import {ReactComponent as MoreIcon} from '../../assets/icons/more.svg';
import {DocumentInDataSource} from '../../models/models';
import {
    ButtonsContainer,
    CardContainer,
    CardContent,
    DateText,
    ExtensionBadge,
    FileInfo,
    FileMetadata,
    FileName,
    OptionsButton,
} from './FileCard.styled';
import FilePreviewDialog from '../common/FilePreviewDialog';
import SearchIcon from '@mui/icons-material/Search';

type Props = {
    document: DocumentInDataSource;
    selected: boolean;
    onToggle: (docId: number) => void;
    onOptionsClick?: (event: React.MouseEvent, document: DocumentInDataSource) => void;
};

const FileCard: React.FC<Props> = ({
    document,
    selected,
    onToggle,
    onOptionsClick,
}) => {
    const [openPreview, setOpenPreview] = useState(false);
    const handleCardClick = (e: React.MouseEvent) => {
        if ((e.target as HTMLElement).closest('.options-button')) {
            return;
        }
        onToggle(document.id);
    };

    const handleOptionsClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onOptionsClick?.(e, document);
    };

    const formatDate = (dateString: string) => {
        try {
            return new Date(dateString).toLocaleDateString();
        } catch {
            return dateString;
        }
    };

    const openFilePreview = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpenPreview(true);
    }

    const closeFilePreview = () => {
        setOpenPreview(false);
    };

    return (
        <CardContainer $selected={selected} onClick={handleCardClick}>
            <CardContent>
                <ButtonsContainer>
                    <Checkbox
                        checked={selected}
                        onChange={() => onToggle(document.id)}
                        onClick={(e) => e.stopPropagation()}
                        size="small"
                        sx={{
                            padding: '0',
                            '& .MuiSvgIcon-root': {
                                fontSize: 18
                            }
                        }}
                    />

                    <SearchIcon onClick={openFilePreview} style={{width: '19px', height: '19px'}}/>
                    <FilePreviewDialog open={openPreview}
                                       docId={document.id}
                                       onClose={closeFilePreview}
                                       fileName={document.name}/>
                </ButtonsContainer>
                <FileInfo>
                    <FileName title={document.name}>{document.name}</FileName>
                    <FileMetadata>
                        {document.extension && document.extension.trim() !== '' && (
                            <>
                                <ExtensionBadge>{document.extension}</ExtensionBadge>
                                <DateText>•</DateText>
                            </>
                        )}
                        <DateText>{formatDate(document.createdAt)}</DateText>
                    </FileMetadata>
                </FileInfo>
                {onOptionsClick && (
                    <OptionsButton
                        className="options-button"
                        size="small"
                        onClick={handleOptionsClick}
                    >
                        <MoreIcon />
                    </OptionsButton>
                )}
            </CardContent>
        </CardContainer>
    );
};

export default FileCard;
